<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">本模块用于建立等高裤衩箱梁的折面梁格模型。</div>
    <div class="content-guide" style="font-weight: 600">
      本模块支持等高箱梁的曲线布置、变宽布置和裤衩方式布置。同时也适用于等高箱梁的斜交布置。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url2"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList2"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      对于裤衩箱梁来说，折面梁格建模最麻烦的部分在于箱梁分割离散后节点的坐标计算，以及分割后
      截面的定义非常麻烦。程序按照路线、路基宽度的相互关系，采用数学几何的方式换算节点坐标，
      然后再根据节点坐标来分割截面，自行换算并生成各个单元截面。这样就大大减少了参数输入量，
      降低了建模难度，加快了建模速度。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>引入桥梁涉及掉的所有路线文件</li>
      <li>定义各条路线桥面布置参数（桥面宽度布置）</li>
      <li>选择基本参数，汽车荷载，输入人群荷载</li>
      <li>输入桥面铺装厚度</li>
      <li>定义桥跨布置、横梁的桩号位置</li>
      <li>定义外翼缘宽度，计算横梁长度</li>
      <li>定义每一跨腹板数量及腹板间距</li>
      <li>根据需要调整箱梁各个部位的尺寸参数</li>
      <li>根据需要调整支座参数</li>
      <li>切换到“预应力”窗口，分别定义腹板束、顶板束、底板束、横梁束</li>
      <li>切换到“其他参数”窗口，定义普通钢筋参数</li>
      <li>定义汽车车道信息</li>
      <li>定义网格划分信息</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url3"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList3"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">路线资料</div>
    <div class="content-guide">
      <li>控制路线条数</li>
      <div>根据桥梁左右边缘线、横梁位置定义所涉及到的路线条数输入。</div>
      <div style="font-weight: 600">
        输入数值后一定要在键盘上按“Enter”键，才可以看到下方表格中出现相应路线编号。
      </div>
      <li>选择要导入、定义的路线编号。</li>
      <li>点击“路线导入”，选择对应的路线文件（目前仅支持纬地软件和自定义格式文件）。</li>
      <div>.pm格式为纬地软件的平面格式</div>
      <div>.txt格式为本软件其他模块支持的自定义路线文件格式</div>
      <li>点击“桥面宽度”，定义该路线对应的路基桥面宽度。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 199px; height: 245px" :src="url4" :fit="fit" />
      </div>
    </div>
    <div class="content-guide" style="font-weight: 600">
      <li>注意事项</li>
      <div>
        路线文件的导入顺序有专门的要求！需要以拟定的桥梁前进方向，由左向右逐条导入。
      </div>
      <div>如果导入顺序有误，会导致后面各个参数出错！</div>
      <div>路线平面位置应位于左右两侧边腹板宽度范围内，否则会造成横梁长度计算错误！</div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面宽度</div>
    <div class="content-guide">
      <li>
        桥面宽度定义主要用于计算桥梁左右外轮廓线准确坐标，故仅外侧的路线需要输入桥面宽度。
      </li>
      <li>
        W1～W5、W7～W12——对应示意图各部位宽度。程序会将W1～W12的数值相加再考虑加宽值作为路基的总宽度。
      </li>
      <li>荷载Q1～Q5——该荷载为除桥面铺装以外作用在桥面的其他荷载。</li>
      <div>Q1对应W1、W12宽度范围内的荷载（如人行道护栏、防撞护栏自重），</div>
      <div>Q2对应W2、W11宽度范围内的荷载(如人行道板自重)，</div>
      <div>
        Q3对应W3、W10宽度范围内的荷载（如非机动车道铺装调平层除开等厚部分自重），
      </div>
      <div>Q4对应W4、W9宽度范围内的荷载（如快慢车道分隔带自重），</div>
      <div>
        Q5对应W5、W8宽度范围内的荷载（如主行车道铺装调平层除开等厚部分自重），
      </div>
      <div>特别注意荷载Q1～Q6的单位为kPa，即kN/m2。</div>
      <li>桥面加宽参数：</li>
      <div>
        选择对应的公路等级及加宽类别，点击计算，程序会根据输入的路线文件自动进行计算，计算数值显示在文本框内。
      </div>
      <div>你也可以点击“+”按钮增加加宽位置，输入对应桩号的加宽值。</div>
      <div>表中“类型”的意义：输入1——按直线加宽，输入n——按n次抛物线加宽</div>
      <div>特别注意：程序自动生成的路线起止桩号最好不要删除，若有加宽请增加新的行，防止桥梁宽度计算错误</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 237px"
          :src="url5"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList5"
          :initial-index="0"
          fit="fill"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">基本参数</div>
    <div class="content-guide">
      <li>混凝土标号——选择箱梁混凝土采用的标号</li>
      <li>预应力钢材——选择箱梁采用的预应力钢束型号</li>
      <li>预应力管道——选择箱梁预应力钢束采用的管道类型</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 197px; height: 116px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活载</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>人群荷载——考虑人行道宽度后的人群荷载，不考虑人群荷载时输入0。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 196px; height: 96px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面铺装</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入桥面沥青混凝土层的厚度。
        模型中该厚度乘以行车道宽度及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以桥梁全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 196px; height: 86px" :src="url8" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">辅助工具</div>
    <div class="content-guide">
      <li>
        本工具用于生成路线图形、箱梁轮廓图形，方便将图形叠加到道路图中校队准确位置。
      </li>
      <li>路线绘图——勾选后能生成所有路线的平面图形。</li>
      <li>箱梁轮廓绘图——勾选后能生成箱梁的外轮廓图形。</li>
      <li>模型单元图——勾选后能生成导出模型的所有单元图形</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 196px; height: 192px" :src="url9" :fit="fit" />
      </div>
    </div>
    <div class="content-guide">
      <li>注意事项：</li>
      <div>路线导入后即可勾选“路线绘图”生成DXF文件，方便校验路线文件数据的正确性</div>
    </div>    
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥跨布置</div>
    <div class="content-guide">
      <li>桥梁最大跨数——输入桥梁的跨数</li>
      <div style="font-weight: 600">
        输入数值后一定要在键盘上按“Enter”键，才可以看到下方表格中出现相应数据
      </div>
      <li>
        横梁对应桩号——横梁位置由路线桩号确定。当横梁为折线时，需分别指定每段对应的路线桩号，
        即填写的每一个桩号对应横梁的一段，没有的填-1
      </li>
      <li>
        横梁斜交角度——前表对应位置横梁线的斜交角度，顺时针旋转为正值，逆时针旋转为负值
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 605px; height: 268px" :src="url10" :fit="fit" />
      </div>
    </div>
    <div class="content-guide">
      <li>
        翼缘悬臂宽——外翼缘的总悬臂宽度，该宽度在第一次定义并使用后，
        可以在其他参数的“翼缘变宽”功能内精细调整每一道横梁处左右两侧的翼缘悬臂宽度，
        即实现翼缘悬臂变宽
      </li>
      <li>
        计算横梁长度——点击后将根据定义的横梁处翼缘宽度自动计算每一道横梁各个段落的长度
      </li>
      <div style="font-weight: 600">横梁长度将用于计算腹板间距等参数</div>
      <li>厚度、高度——每一道横梁的顺桥向宽度和高度</li>
    </div>
  </section>
  <div class="img-guide">
    <div class="title-img">
      <el-image style="width: 605px; height: 232px" :src="url11" :fit="fit" />
    </div>
  </div>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">腹板布置</div>
    <div class="content-guide">
      <li>腹板数量——定义每一跨的腹板数量</li>
      <li>计算腹板间距——点击后将根据定义的腹板数量自动计算每一道腹板的间距</li>
      <div style="font-weight: 600">
        若该数量修改后，则会按该数值重新计算每一跨腹板参数，
        若未修改，则按下方表格中定义的腹板数重新计算腹板间距
      </div>
      <li>腹板宽度——自动计算时采用的腹板宽度</li>
      <li>腹板数——定义每一跨的腹板数，允许各跨腹板数不同</li>
      <li>腹板厚——每一道腹板跨中段的水平宽度</li>
      <li>腹板i端、j端定位——每一道腹板两端的间距，允许前后跨腹板中线不重合</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 605x; height: 267px" :src="url12" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url12a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">高度尺寸</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中高度尺寸。</li>
      <li>各参数意义如下：</li>
      <div>梁高H1、H2——跨中段和墩顶段的梁高</div>
      <div>顶板高H3——跨中段顶板厚度</div>
      <div>底板高H4——跨中段底板厚度</div>
      <div>底部长L1、L2——横梁部位加厚段的长度</div>
      <li>“全桥统一”——将第一跨参数复制给其他跨</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 282px" :src="url13" :fit="fit" />
      </div>
      <el-image style="width: 522px; height: 305px" :src="url13a" :fit="fit" />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">纵向立面尺寸</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>端横梁顶板尺寸L3～L5、H5～H6——端横梁顶板加厚段尺寸</div>
      <div>端横梁底板尺寸L9～L11、H9～H10——端横梁顶板加厚段尺寸</div>
      <div>中横梁顶板尺寸L6～L8、H7～H8——端横梁顶板加厚段尺寸</div>
      <div>中横梁底板尺寸L12～L14、H11～H12——端横梁顶板加厚段尺寸</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 175px" :src="url14" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url14a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url14b"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">纵向平面尺寸</div>
    <div class="content-guide">
      <li>本部分填写箱梁平面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>端横梁边腹板尺寸L15～L17、H13～H14——端横梁边腹板加厚段尺寸</div>
      <div>端横梁中腹板尺寸L21～L23、H17～H18——端横梁中腹板加厚段尺寸</div>
      <div>中横梁边腹板尺寸L18～L20、H15～H16——端横梁边腹板加厚段尺寸</div>
      <div>中横梁中腹板尺寸L24～L26、H19～H20——端横梁中腹板加厚段尺寸</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 175px" :src="url15" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url15a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url15b"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">隔板尺寸</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>底长L1——对应桥墩0号块底面等高段长度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 146px" :src="url16" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url16a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">横向尺寸</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>B1——箱梁边腹板的斜率，垂直腹板填0</div>
      <div>B2——外悬臂底面段宽度，没有该转点可以输入0.001</div>
      <div>高度H21～H23——悬臂部分各段高度</div>
      <div>倒角D1～D9——边腹板、中腹板的顶底板倒角</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 195px" :src="url17" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url17a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url17b"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">支座</div>
    <div class="content-guide">
      <li>本部分填写箱梁标准横断面的部分尺寸参数。</li>
      <li>各参数意义如下：</li>
      <div>纵向D——支座在横梁位置相对梁端或横梁中心线纵向的位置</div>
      <div>横向布置——每个墩台位置横桥向支座的间距</div>
      <div>
        重新布置——填写好横向布置后，点击该按钮将重新计算支座的个数及约束类型
      </div>
      <div>
        支座1～支座n——每一个支座的约束类型（有4种，详见下方示意图），可以填写1～4。
        约束类型涉及到导出模型的边界条件是否正确，如果无把握正确填写，则建议尽量使用默认的约束类型。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 550px; height: 184px" :src="url18" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <el-image
          style="width: 522px; height: 305px"
          :src="url18a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url18b"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url18c"
          :fit="fit"
        />
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——腹板束——端横梁部位（立面）</div>
    <div class="content-guide">
      <li>本部分填写箱梁腹板钢束端横梁部位立面形状参数</li>
      <li>各参数意义如下：</li>
      <div>编号——钢束的编号，允许自行修改，应确保不重复</div>
      <div>
        腹板号——本钢束形状适用的腹板号，可以使用“-”和“，”号分隔，如“1,3,5”
      </div>
      <div>组数——同一道腹板内相同线型的钢束孔道数，用YD1参数来确定横向间距</div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>YD1——相同线型的钢束孔道水平距离</div>
      <div>YL1——钢束张拉端距离箱梁端部的水平距离。</div>
      <div>YL2——钢束张拉端水平段长度，本长度允许为0。</div>
      <div>YL3——钢束张拉端倾斜段长度，本长度不允许为0，至少需要填0.01。</div>
      <div>YH1——钢束张拉端距箱梁底面距离。</div>
      <div>YH2——钢束边跨中间段距箱梁底面距离。</div>
      <div>YR1——第1个转点半径，没有时可以填0。</div>
      <div>YR2——第2个转点半径。</div>
      <li>两端位置——箱梁两端参数是独立的，通过本选择框进行切换。</li>
      <li>
        两端相同——勾选后会将腹板钢束起点端参数复制给终点端，包括立面参数和平面参数。
      </li>
      <li>通过“+”和“-”按钮可以增加和减少钢束数量。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 123px" :src="url19" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <el-image
          style="width: 522px; height: 305px"
          :src="url19a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url19b"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url19c"
          :fit="fit"
        />
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——腹板束——端横梁部位（平面）</div>
    <div class="content-guide">
      <li>本部分填写箱梁腹板钢束端横梁部位平面形状参数</li>
      <li>各参数意义如下：</li>
      <div>PL1——钢束张拉端直线段长度。</div>
      <div>PL2——钢束张拉端收紧段长度。</div>
      <div>
        PB1——边腹板对应左侧第一道钢束的横向内移值，中腹板对应左侧第一道钢束的横向外移值。
      </div>
      <div>PB2——钢束之间的横向间距。</div>
      <div>PR1——第1个转点半径，没有时可以填0。</div>
      <div>PR2——第2个转点半径。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 104px" :src="url20" :fit="fit" />
        <el-image
          style="width: 522px; height: 305px"
          :src="url20a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——腹板束——中横梁部位（立面）</div>
    <div class="content-guide">
      <li>本部分填写箱梁腹板钢束中横梁部位立面形状参数</li>
      <li>各参数意义如下：</li>
      <div>YL4——桥墩处钢束前一跨倾斜段水平长度</div>
      <div>YL5——桥墩处钢束前一跨水平段长度</div>
      <div>YL6——桥墩处钢束后一跨水平段长度</div>
      <div>YL7——桥墩处钢束后一跨倾斜段水平长度</div>
      <div>YH3——桥墩处前一跨中间段距箱梁底面距离。</div>
      <div>YH4——桥墩处水平段距箱梁顶面距离。</div>
      <div>YH5——桥墩处后一跨中间段距箱梁底面距离。</div>
      <div>YR3——桥墩处钢束第1个转点半径。</div>
      <div>YR4——桥墩处钢束第2个转点半径。</div>
      <div>YR5——桥墩处钢束第3个转点半径。</div>
      <div>YR6——桥墩处钢束第4个转点半径。</div>
      <div>
        注意控制水平段长度与转点半径关系，避免出现桥墩第2转点与第3转点圆曲线重合导致的钢束形状错误问题。
      </div>
      <li>
        中横梁编号——箱梁每一道中横梁处参数是独立的，通过本选择框进行切换。
      </li>
      <li>多跨相同——勾选后会将1号横梁部位腹板钢束参数复制给其他横梁处。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 114px" :src="url21" :fit="fit" />
      </div>
        <el-image
          style="width: 522px; height: 305px"
          :src="url21a"
          :fit="fit"
        />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——顶板束</div>
    <div class="content-guide">
      <li>本部分填写箱梁顶板钢束立面形状参数</li>
      <li>各参数意义如下：</li>
      <div>编号——钢束的编号，允许自行修改，应确保不重复</div>
      <div>
        腹板号——本钢束形状适用的腹板号，可以使用“-”和“，”号分隔，如“1,3,5”
      </div>
      <div>
        布跨——该钢束起终点的位置基准位置。
        由2个墩台号用“-”号相连，起点位置计算基准为第1个数字代表的墩台编号，终点位置计算基准为第2个数字代表的墩台编号。
      </div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>YL1——顶板钢束起点端弯起段水平长度</div>
      <div>
        YL2——顶板钢束起点端弯起段转点到墩台（墩台编号为布跨中第1个数字代表的墩台编号）距离。
      </div>
      <div>
        YL3——顶板钢束墩台（墩台编号为布跨中第2个数字代表的墩台编号）到终点端弯起段转点距离。
      </div>
      <div>YL4——顶板钢束终点端弯起段水平长度</div>
      <div>YH1——顶板钢束起点端到箱梁顶面距离</div>
      <div>YH2——顶板钢束平直段到箱梁顶面距离</div>
      <div>YH3——顶板钢束终点端到箱梁顶面距离</div>
      <div>YR1——钢束第1个转点半径。</div>
      <div>YR2——钢束第2个转点半径。</div>
      <div>
        YB1——孔道与腹板基准线的横向水平距离。鼠标点击本单元格可以看到对应右侧示意图。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 114px" :src="url22" :fit="fit" />
      </div>
        <el-image
          style="width: 522px; height: 305px"
          :src="url22a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url22b"
          :fit="fit"
        />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——底板束</div>
    <div class="content-guide">
      <li>本部分填写箱梁底板钢束立面形状参数</li>
      <li>各参数意义如下：</li>
      <div>编号——钢束的编号，允许自行修改，应确保不重复</div>
      <div>
        腹板号——本钢束形状适用的腹板号，可以使用“-”和“，”号分隔，如“1,3,5”
      </div>
      <div>
        布跨——该钢束起终点的位置基准位置。
        由2个墩台号用“-”号相连，起点位置计算基准为第1个数字代表的墩台编号，终点位置计算基准为第2个数字代表的墩台编号。
      </div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>YL1——底板钢束起点端弯起段水平长度</div>
      <div>
        YL2——底板钢束起点端弯起段转点到墩台（墩台编号为布跨中第1个数字代表的墩台编号）距离。
      </div>
      <div>
        YL3——底板钢束墩台（墩台编号为布跨中第2个数字代表的墩台编号）到终点端弯起段转点距离。
      </div>
      <div>YL4——底板钢束终点端弯起段水平长度</div>
      <div>YH1——底板钢束起点端到箱梁顶面距离</div>
      <div>YH2——底板钢束平直段到箱梁顶面距离</div>
      <div>YH3——底板钢束终点端到箱梁顶面距离</div>
      <div>YR1——钢束第1个转点半径。</div>
      <div>YR2——钢束第2个转点半径。</div>
      <div>
        YB1——孔道与腹板基准线的横向水平距离。鼠标点击本单元格可以看到对应右侧示意图。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 114px" :src="url23" :fit="fit" />
      </div>
        <el-image
          style="width: 522px; height: 305px"
          :src="url23a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url23b"
          :fit="fit"
        />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力——横梁束</div>
    <div class="content-guide">
      <li>本部分填写横梁钢束立面形状参数</li>
      <li>各参数意义如下：</li>
      <div>编号——钢束的编号，允许自行修改，应确保不重复</div>
      <div>组数——该种形状钢束在横梁中的孔数</div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>间距A——当仅2个转折点时，仅需填一个数值，若多个转折点，则可输入多个间距，用“，”分隔</div>
      <div>YL1～YL6——如示意图各个段落水平长度</div>
      <div>YH1～YH4——如示意图各个段落竖向高度</div>
      <div>YR1～YR3——各个转折点的半径</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 114px" :src="url24" :fit="fit" />
      </div>
        <el-image
          style="width: 522px; height: 305px"
          :src="url24a"
          :fit="fit"
        />
        <el-image
          style="width: 522px; height: 305px"
          :src="url24b"
          :fit="fit"
        />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——主梁钢筋</div>
    <div class="content-guide">
      <li>本部分仅用于填写腹板梁的普通钢筋参数，二字形截面不考虑布置普通钢筋</li>
      <li>
        普通钢筋参数分主梁纵向抗弯钢筋和腹板抗剪箍筋2类。
        程序会根据跨中截面标准段和每一跨端部腹板变宽段作为正弯矩区和负弯矩区的划分。
      </li>
      <li>主梁抗弯钢筋</li>
      <div>
        纵向钢筋在高度方向上将钢筋分为4层，纵向上分为支座加强区与跨中常规区2类。
        参数包括各层钢筋的直径、间距、保护层厚度。
      </div>
      <li>主梁腹板抗剪钢筋</li>
      <div>
        横向箍筋则仅在纵向上分为支座加强区与跨中常规区2类。
        参数包括箍筋直径、肢数、桥长方向间距。
        注意箍筋肢数指的是单个腹板竖向钢筋根数，即一个箍筋算2肢。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 604px; height: 260px" :src="url25" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url25a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——汽车车道</div>
    <div class="content-guide">
      <li>主车道计算车道数——由于主车道存在变宽问题，故需手工确认主车道的计算车道数，辅车道的车道数程序自动根据宽度计算</li>
      <li>左侧车道起点、终点偏移——偏左车道在起终点内移的宽度</li>
      <li>右侧车道起点、终点偏移——偏右车道在起终点内移的宽度</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 189px; height: 167px" :src="url26" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——翼缘变宽</div>
    <div class="content-guide">
      <li>勾选“翼缘宽度自定义”后，将可以自行定义各个墩台线处左右侧翼缘宽度</li>      
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 257px; height: 212px" :src="url27" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——腹板线型</div>
    <div class="content-guide">
      <li>勾选“腹板线型定义”后，将可以定义每一跨每道腹板的线型</li>
      <li>基本参数意义如下：</li>
      <div>腹板线型——可以选择直线、圆弧、路线3种方式，通过单击单元格切换</div>
      <div>前后端编号——当选择路线时，填入该腹板前后端对应的路线线型</div>
      <div>曲线半径——当选择圆弧时，填入腹板线型对应的圆弧半径</div>
      <div>偏转方向——当选择圆弧时，填入0代表左偏，填入1代表右偏</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 454px; height: 193px" :src="url28" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——网格划分</div>
    <div class="content-guide">
      <li>可以选择按规范有效宽度自动计算腹板梁的翼缘宽度，也可以选择自定义腹板梁的翼缘宽度</li>
      <li>划分数量——腹板主梁间剩余部分的横向划分数量</li>
      <li>可以每跨单独定义每个箱室的横向划分数量</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 286px; height: 371px" :src="url29" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——导出模型</div>
    <div class="content-guide">
      <li>选择钢筋混凝土模型，则导出模型中不含预应力钢束部分内容</li>
      <li>模型旋转角度——输入角度可以让模型在civil中平转，正值顺时针，负值逆时针</li>
      <li>虚拟横梁间距——用于控制横向虚拟横梁顺桥向的间距，单位为m</li>      
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 298px; height: 213px" :src="url30" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit7/1.png"),
      url2: require("@/assets/png/unit7/2.png"),
      url2a: require("@/assets/png/unit7/2-1.png"),
      url3: require("@/assets/png/unit7/3.png"),
      url4: require("@/assets/png/unit7/4.png"),
      url5: require("@/assets/png/unit7/5.png"),
      url6: require("@/assets/png/unit7/6.png"),
      url7: require("@/assets/png/unit7/7.png"),
      url8: require("@/assets/png/unit7/8.png"),
      url9: require("@/assets/png/unit7/9.png"),
      url10: require("@/assets/png/unit7/10.png"),
      url11: require("@/assets/png/unit7/11.png"),
      url12: require("@/assets/png/unit7/12.png"),
      url12a: require("@/assets/png/unit7/12-1.png"),
      url13: require("@/assets/png/unit7/13.png"),
      url13a: require("@/assets/png/unit7/13-1.png"),
      url14: require("@/assets/png/unit7/14.png"),
      url14a: require("@/assets/png/unit7/14-1.png"),
      url14b: require("@/assets/png/unit7/14-2.png"),
      url15: require("@/assets/png/unit7/15.png"),
      url15a: require("@/assets/png/unit7/15-1.png"),
      url15b: require("@/assets/png/unit7/15-2.png"),
      url16: require("@/assets/png/unit7/16.png"),
      url16a: require("@/assets/png/unit7/16-1.png"),
      url17: require("@/assets/png/unit7/17.png"),
      url17a: require("@/assets/png/unit7/17-1.png"),
      url17b: require("@/assets/png/unit7/17-2.png"),
      url18: require("@/assets/png/unit7/18.png"),
      url18a: require("@/assets/png/unit7/18-1.png"),
      url18b: require("@/assets/png/unit7/18-2.png"),
      url18c: require("@/assets/png/unit7/18-3.png"),
      url19: require("@/assets/png/unit7/19.png"),
      url19a: require("@/assets/png/unit7/19-1.png"),
      url19b: require("@/assets/png/unit7/19-2.png"),
      url19c: require("@/assets/png/unit7/19-3.png"),
      url20: require("@/assets/png/unit7/20.png"),
      url20a: require("@/assets/png/unit7/20-1.png"),
      url21: require("@/assets/png/unit7/21.png"),
      url21a: require("@/assets/png/unit7/21-1.png"),
      url22: require("@/assets/png/unit7/22.png"),
      url22a: require("@/assets/png/unit7/22-1.png"),
      url22b: require("@/assets/png/unit7/22-2.png"),
      url23: require("@/assets/png/unit7/23.png"),
      url23a: require("@/assets/png/unit7/23-1.png"),
      url23b: require("@/assets/png/unit7/23-2.png"),
      url24: require("@/assets/png/unit7/24.png"),
      url24a: require("@/assets/png/unit7/24-1.png"),
      url24b: require("@/assets/png/unit7/24-2.png"),
      url25: require("@/assets/png/unit7/25.png"),
      url25a: require("@/assets/png/unit7/25-1.png"),
      url26: require("@/assets/png/unit7/26.png"),
      url27: require("@/assets/png/unit7/27.png"),
      url28: require("@/assets/png/unit7/28.png"),
      url29: require("@/assets/png/unit7/29.png"),
      url30: require("@/assets/png/unit7/30.png"),
      fit: "fill",
      srcList2: [
        require("@/assets/png/unit7/2.png"),
        require("@/assets/png/unit7/2-1.png"),
      ],
      srcList3: [
        require("@/assets/png/unit7/3.png"),
        require("@/assets/png/unit7/3-1.png"),
        require("@/assets/png/unit7/3-2.png"),
      ],
      srcList5: [require("@/assets/png/unit7/5.png")],
    };
  },
};
</script>
